import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_PROFILE_CHANNEL } from './url-constants';

type ManageProfileChannelsEndpointSpecification = ApiEndpointSpecification;
export const ManageProfileChannelsEndpointSpecification: ManageProfileChannelsEndpointSpecification = {
    url: MANAGE_PROFILE_CHANNEL,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'ManageProfileChannelsRequestParams',
    requestBodySchemaName: 'ManageProfileChannelsRequestBody',
    okResponseSchemaName: 'ManageProfileChannelsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageProfileChannelsData = Helpers.makeApiRequestFn<
    Types.ManageProfileChannelsRequestParams,
    Types.ManageProfileChannelsRequestBody,
    Types.ManageProfileChannelsOkResponse
>(ManageProfileChannelsEndpointSpecification);
